module.exports = __webpack_public_path__ + "img/info.443da8d6.png";